import { AxiosError } from 'axios';
import {
  MutationFunction,
  useMutation,
  UseMutationResult,
  useQueryClient
} from 'react-query';
import { Axios } from '@utils/api/axios-instance.ts';
import { BaseError } from '@utils/types/shared/base.ts';
import { POST_URL } from '@utils/api/endpoints.ts';
import { TagAssignment } from '@utils/types/organization/tag.ts';

type CreateTagAssignmentVariables = {
  session_id: string;
  document_id: string;
  tag_id: number;
  selected_text: string;
  index_from?: string;
  index_to?: string;
  timestamp_from?: string;
  timestamp_to?: string;
};

export const useCreateTagAssignment = (): UseMutationResult<
  TagAssignment,
  AxiosError<BaseError>,
  CreateTagAssignmentVariables,
  unknown
> => {
  const queryClient = useQueryClient();

  const createTagAssignment: MutationFunction<
    TagAssignment,
    CreateTagAssignmentVariables
  > = async ({
    session_id,
    document_id,
    tag_id,
    selected_text,
    index_from,
    index_to,
    timestamp_from,
    timestamp_to
  }) => {
    const response = await Axios.post<TagAssignment>(
      POST_URL(session_id, document_id).createTagAssignment,
      {
        tag_id,
        selected_text,
        index_from,
        index_to,
        timestamp_from,
        timestamp_to
      }
    );
    return response.data;
  };

  return useMutation(createTagAssignment, {
    onSuccess: (_data, vars) => {
      queryClient.invalidateQueries([
        'tagAssignments',
        vars.session_id,
        vars.document_id
      ]);
    }
  });
};
